import {
  ActivateAccountRequest,
  ActivateAccountResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../axios';

// This is the service called when a user clicks the verification link sent to their email after the registration process.
// The link will look something like '/verify?token=test&email=email@email.com'. The arguments for this request are taken
// from the query string.
export const emailLinkConfirmation = async (
  requestBody: ActivateAccountRequest
) => {
  const { data } = await axios.post<ActivateAccountResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/activate-account
    `,
    requestBody
  );

  return data;
};

export const useEmailLinkMutation = () =>
  useMutation({
    mutationFn: (requestBody: ActivateAccountRequest) =>
      emailLinkConfirmation(requestBody),
  });
